import { useHistory } from "react-router-dom";
import { errorMessage } from "../helpers";

const Layout = ({ children }) => {

    let history = useHistory()
    let pastScreen = localStorage.getItem('pastScreen')
    let isEmployee = JSON.parse(localStorage.getItem('isEmployee'))
    let accessToken = localStorage.getItem('access_jwt')

    //  

    if (!accessToken) {


        if (isEmployee === false && pastScreen === 'Applicant') {
            localStorage.clear()
            history.push('/')
            errorMessage()
            return <></>
        }


        if (isEmployee === false && pastScreen === 'Employee') {
            localStorage.clear()
            history.push('/login/140040')
            errorMessage()
            return <></>
        }

        if (isEmployee === true && pastScreen === 'Employee') {
            localStorage.clear()
            history.push('/login/140040')
            errorMessage()
            return <></>
        }

        //  
        localStorage.clear()
        history.push('/')
        errorMessage()
        return <></>

    }


    // if (isEmployee === false && pastScreen === 'Applicant') {
    //     history.push('/')
    //     return <></>
    // }


    // if (isEmployee === false && pastScreen === 'Employee') {
    //     history.push('/login/140040')
    //     return <></>
    // }

    // if (isEmployee === false && pastScreen === 'Applicant') {
    //     history.push('/')
    //     return <></>
    // }

    return children
}

export default Layout